import {
  VisitSkeleton, VisitMobileSkeleton, PatientDetailSkeleton, PatientDetailMobileSkeleton,
} from '@parsina/framework/clinical';
import { useTranslation } from '../../i18n';
import useResponsive from '../../hooks/useResponsive';

/**
 * The shape of a clinical screen while it is not there yet — the kit's own
 * skeletons, so nothing jumps when the real screen replaces them.
 *
 * Shown in TWO places, and in both a blank would be a defect: as the router's
 * fallback while the clinical chunk loads (screens/skeletons.jsx), and by
 * ClinicalFrame while the clinical language pack loads. The label comes from
 * THIS panel's catalogue, because neither moment has the clinical one yet.
 *
 * @param {object} props
 * @param {'visit'|'record'} props.kind
 * @param {string} [props.tab]  the record section being opened
 */
export default function ClinicalSkeleton({ kind, tab }) {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const label = t('common.state.loading');
  if (kind === 'visit') {
    return isMobile ? <VisitMobileSkeleton label={label} /> : <VisitSkeleton label={label} />;
  }
  return isMobile
    ? <PatientDetailMobileSkeleton tab={tab || 'overview'} label={label} />
    : <PatientDetailSkeleton tab={tab || 'overview'} label={label} />;
}
